<template>
  <div id="container">
    <v-checkbox
      id="consent-checkbox"
      v-model="this.consent"
      color="anchor"
      hide-details="true"
      required
      @update:model-value="setGlobalConsentState"
    >
      <template v-slot:label>
        <label
          for="consent-checkbox"
          v-html="
            sanitize($rttI18n.tenantSpecificContent('consentDeclaration'), {
              ADD_ATTR: ['target']
            })
          "
          v-on:click.stop
        />
      </template>
    </v-checkbox>
    <v-checkbox
      v-if="$rttI18n.isGlsAtSelected"
      id="ads-consent-checkbox"
      v-model="this.consentForAds"
      color="anchor"
      hide-details="true"
      required
      @update:model-value="setGlobalConsentStateForAds"
    >
      <template v-slot:label>
        <label
          for="ads-consent-checkbox"
          v-html="
            sanitize(
              $rttI18n.tenantSpecificContent('secondConsentDeclaration'),
              { ADD_ATTR: ['target'] }
            )
          "
          v-on:click.stop
        />
      </template>
    </v-checkbox>
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useGdprStore } from '@/stores/gdpr.js';
import DOMPurify from 'dompurify';

export default {
  name: 'GDPRConsentComponent',
  data: function () {
    return {
      consent: undefined,
      consentForAds: undefined
    };
  },
  methods: {
    sanitize: DOMPurify.sanitize,
    ...mapActions(useGdprStore, ['setGdprConsent']),
    ...mapState(useGdprStore, ['gdprConsent']),
    setGlobalConsentState() {
      this.setGdprConsent({
        tenantId: this.$rttI18n.tenantId,
        value: this.consent
      });
    },
    setGlobalConsentStateForAds() {
      this.setGdprConsent({
        tenantId: `${this.$rttI18n.tenantId}-ads`,
        value: this.consentForAds
      });
    }
  },
  mounted() {
    this.consent = !!this.gdprConsent()[this.$rttI18n.tenantId];
    this.consentForAds = !!this.gdprConsent()[`${this.$rttI18n.tenantId}-ads`];
  }
};
</script>

<style scoped>
div#container {
  padding-bottom: 1.5em;
}
</style>
